import React, { useEffect } from "react";
import { ChoiceGroup, IChoiceGroupOption } from "@fluentui/react";
import { formatMessage } from "../../../utils/helpers/LanguageHelper";
import { ObjectPanelTabs } from "../co-panel/ObjectPanelComponent";
import { CoObjectAdvanced } from "../../interfaces/CoObject";
import { DocumentPartMetadata } from "../../../api/models/document-part-metadata";

interface CoObjectAdvancedTableProps {
  documentPartMetadata: DocumentPartMetadata;
  objectAdvanced: CoObjectAdvanced;
  updateCoObjectAdvancedTable: (obj: CoObjectAdvanced, tabValid, modified: boolean) => void;
  tab: ObjectPanelTabs;
  isEdit: boolean;
  isLocked: boolean;
  isFileExcelExisting?: boolean;
  isComponentInstance?: boolean;
}

const getAdvancedTable = (
  objectAdvanced: CoObjectAdvanced,
  isEdit: boolean,
  isComponentInstance: boolean,
  documentPartMetadata: DocumentPartMetadata
): CoObjectAdvanced => {
  if (isEdit || isComponentInstance) {
    return objectAdvanced;
  }

  return {
    choice: "SOURCE",
    inheritFormat: false,
    formatMetadata: {
      locale: documentPartMetadata?.formatMetadata?.locale,
    },
    language: documentPartMetadata?.language,
  };
};

export const CoObjectAdvancedTablePanel: React.FunctionComponent<CoObjectAdvancedTableProps> = (props) => {
  const {
    documentPartMetadata,
    objectAdvanced,
    updateCoObjectAdvancedTable,
    isEdit,
    isLocked,
    isFileExcelExisting,
    isComponentInstance,
  } = props;
  const options: IChoiceGroupOption[] = [
    {
      key: "DOCUMENT_ROOT",
      text: formatMessage("cof.createnewobject.documentroot"),
    },
    { key: "SOURCE", text: formatMessage("cof.createnewobject.source") },
  ];

  useEffect(() => {
    getInitialDocumentSettings();
  }, []);

  async function getInitialDocumentSettings() {
    const updatedAdvanced = getAdvancedTable(objectAdvanced, isEdit, isComponentInstance, documentPartMetadata);
    updateCoObjectAdvancedTable(updatedAdvanced, validateFields(updatedAdvanced), !isEdit);
  }

  const onChangeFormattingAs = (_: React.SyntheticEvent<HTMLElement>, option: IChoiceGroupOption) => {
    const isSource = option.key === "SOURCE";

    const updatedAdvanced: CoObjectAdvanced = {
      choice: isSource ? "SOURCE" : "DOCUMENT_ROOT",
      inheritFormat: !isSource,
      formatMetadata: !isSource
        ? documentPartMetadata?.formatMetadata
        : { locale: documentPartMetadata?.formatMetadata?.locale },
      ...(!isSource && { formatImage: documentPartMetadata?.formatImage }),
      language: documentPartMetadata?.language,
    };

    updateCoObjectAdvancedTable(updatedAdvanced, validateFields(updatedAdvanced), true);
  };

  function validateFields(obj: CoObjectAdvanced): ObjectPanelTabs {
    let isValid = true;
    if (obj == null) isValid = false;
    else {
      const { choice } = obj;

      if (!choice) isValid = false;
    }
    return { key: props.tab.key, name: props.tab.name, isValid: isValid };
  }

  return (
    <div className="ms-Grid" dir="ltr">
      <div className="ms-Grid-row">
        <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12">
          <ChoiceGroup
            selectedKey={objectAdvanced?.choice ?? "SOURCE"}
            styles={{
              flexContainer: { display: "flex", justifyContent: "left", columnGap: "0.5rem", flexWrap: "wrap" },
            }}
            options={options}
            onChange={onChangeFormattingAs}
            label={formatMessage("cof.createnewobject.formatstarting")}
            disabled={!isFileExcelExisting || isComponentInstance || isLocked}
          />
        </div>
      </div>
    </div>
  );
};
